(function () {
  var root = document.documentElement;

  function headerSectionEl() {
    return document.querySelector('header.shopify-section-header');
  }

  function announcementEl() {
    return document.querySelector('.announcement-bar.section');
  }

  function refreshThemeHeaderMetrics() {
    var hc = document.getElementById('header-component');
    if (hc && typeof hc.updatePosition === 'function') {
      try {
        hc.updatePosition();
      } catch (_) {}
    }
  }

  /**
   * Pixels to leave below the top of the viewport. Uses --gsc-header-bottom-side from the
   * theme (HeaderComponent: bottom edge of #header-component in viewport px) when set.
   */
  function measureStickyOffset() {
    refreshThemeHeaderMetrics();
    var st = getComputedStyle(root);
    var bottomSide = parseFloat(st.getPropertyValue('--gsc-header-bottom-side'));
    var wrap = headerSectionEl();
    var ann = announcementEl();
    var hc = document.getElementById('header-component');

    var wrapBottom = 0;
    if (wrap) {
      var wr = wrap.getBoundingClientRect();
      if (wr.height > 0) wrapBottom = wr.bottom;
    }

    var annBottom = 0;
    if (ann && wrap && ann.compareDocumentPosition(wrap) & Node.DOCUMENT_POSITION_FOLLOWING) {
      var ast = getComputedStyle(ann);
      var ar = ann.getBoundingClientRect();
      if (ast.display !== 'none' && ar.height > 0 && ar.bottom > 0 && ar.top < 200) {
        annBottom = ar.bottom;
      }
    }

    var merged = 0;
    if (!isNaN(bottomSide) && bottomSide > 8) {
      merged = bottomSide;
    }
    merged = Math.max(merged, wrapBottom, annBottom);

    if (merged < 8) {
      if (hc) {
        merged = hc.getBoundingClientRect().bottom;
      } else if (wrap) {
        merged = wrapBottom;
      }
    }

    var hVar = parseFloat(st.getPropertyValue('--gsc-header-height'));
    if (!isNaN(hVar) && hVar > 0) {
      merged = Math.max(merged, hVar);
    }

    var rounded = Math.ceil(merged);
    if (rounded < 8) rounded = 80;
    return rounded;
  }

  function setOffsetCssVar() {
    root.style.setProperty('--gutzy-sticky-header-offset', measureStickyOffset() + 'px');
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function normalizePath(p) {
    if (!p || p === '/') return '/';
    return p.replace(/\/+$/, '') || '/';
  }

  function sameDocumentUrl(url) {
    var loc = window.location;
    if (url.origin !== loc.origin) {
      return false;
    }
    return (
      normalizePath(url.pathname) === normalizePath(loc.pathname) &&
      url.search === loc.search
    );
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateScrollTo(targetY, durationMs, done) {
    var startY = window.pageYOffset;
    var dy = targetY - startY;
    if (Math.abs(dy) < 2) {
      window.scrollTo(0, targetY);
      if (done) done();
      return;
    }
    var start = performance.now();
    function frame(now) {
      var elapsed = now - start;
      var t = Math.min(1, elapsed / durationMs);
      var y = startY + dy * easeOutCubic(t);
      window.scrollTo(0, y);
      if (t < 1) {
        requestAnimationFrame(frame);
      } else if (done) {
        done();
      }
    }
    requestAnimationFrame(frame);
  }

  function scrollDocumentToY(y, smooth, onDone) {
    y = Math.max(0, y);
    if (!smooth || prefersReducedMotion()) {
      window.scrollTo(0, y);
      if (onDone) onDone();
      return;
    }
    animateScrollTo(y, 520, onDone);
  }

  function findTargetEl(id) {
    if (!id) return null;
    var el = document.getElementById(id);
    if (el) return el;
    try {
      if (typeof CSS !== 'undefined' && CSS.escape) {
        return document.querySelector('[name="' + CSS.escape(id) + '"]');
      }
    } catch (_) {}
    return document.querySelector('a[name="' + id.replace(/"/g, '') + '"]');
  }

  function scrollToHashTarget(hash, pushHistory, smooth) {
    if (!hash || hash.length < 2) return false;
    var id = decodeURIComponent(hash.slice(1));
    var el = findTargetEl(id);
    if (!el) return false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
      refreshThemeHeaderMetrics();
      setOffsetCssVar();
      var offset = measureStickyOffset();
      var y = el.getBoundingClientRect().top + window.pageYOffset - offset;
      var doSmooth = smooth !== false;
      scrollDocumentToY(y, doSmooth, function () {
        if (pushHistory) {
          try {
            history.pushState(null, '', hash);
          } catch (_) {}
        }
      });
      });
    });
    return true;
  }

  function onInPageAnchorClick(e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var hrefAttr = (a.getAttribute('href') || '').trim();
    if (!hrefAttr || hrefAttr === '#') return;

    if (hrefAttr.charAt(0) === '#') {
      if (hrefAttr.length > 1 && scrollToHashTarget(hrefAttr, true, true)) {
        e.preventDefault();
      }
      return;
    }

    var url;
    try {
      url = new URL(a.href, window.location.href);
    } catch (_) {
      return;
    }
    if (!sameDocumentUrl(url)) {
      return;
    }
    if (!url.hash || url.hash === '#') {
      return;
    }
    if (scrollToHashTarget(url.hash, true, true)) {
      e.preventDefault();
    }
  }

  function onDomReady() {
    if ('scrollRestoration' in history) {
      try {
        history.scrollRestoration = 'manual';
      } catch (_) {}
    }
    setOffsetCssVar();
    window.addEventListener('resize', setOffsetCssVar, { passive: true });
    window.addEventListener('load', function () {
      setOffsetCssVar();
      if (window.location.hash && window.location.hash.length > 1) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            scrollToHashTarget(window.location.hash, false, !prefersReducedMotion());
          });
        });
      }
    });
    window.addEventListener(
      'scroll',
      function () {
        if (window.gutzyHeaderOffsetScrollTimer) {
          clearTimeout(window.gutzyHeaderOffsetScrollTimer);
        }
        window.gutzyHeaderOffsetScrollTimer = setTimeout(setOffsetCssVar, 80);
      },
      { passive: true }
    );
    requestAnimationFrame(function () {
      setOffsetCssVar();
      requestAnimationFrame(setOffsetCssVar);
    });

    document.addEventListener('click', onInPageAnchorClick, { capture: true });

    if (typeof ResizeObserver === 'undefined') return;
    var header = headerSectionEl();
    var hc = document.getElementById('header-component');
    if (header) {
      new ResizeObserver(setOffsetCssVar).observe(header);
    }
    if (hc && hc !== header) {
      new ResizeObserver(setOffsetCssVar).observe(hc);
    }
    var ann = announcementEl();
    if (ann) {
      new ResizeObserver(setOffsetCssVar).observe(ann);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDomReady);
  } else {
    onDomReady();
  }
})();
